module.exports = __webpack_public_path__ + "img/East_Lothian.929b2484.png";